import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: '/',
  },
  {
    path: '/',
    name: 'summary',
    component: require('./../views/SummaryView').default,
  },
  {
    path: '/catalogue/:slug',
    name: 'catalogue',
    component: require('./../views/CatalogueView').default,
    props: true,
  },
]

const router = new VueRouter({
  routes
})

router.afterEach(function (to, from) {

  $eventbus.$emit('search:modal:hide');

  $eventbus.$emit('gtag', { method:'pageview', params: { value: to.fullPath }} );

  let sto = setTimeout(()=>{
    $('html, body').scrollTop(0);
  },400);
});

export default router
